import { Radio, RadioGroup } from '@atlas/ui-primitives'

export interface OptionCard<T extends string> {
	value: T
	title: string
	detail?: string
}

/** A single choice laid out as side-by-side cards, the selected one highlighted. */
export function OptionCards<T extends string>({
	label,
	options,
	value,
	onChange,
}: {
	/** Accessible name of the group. */
	label: string
	options: readonly OptionCard<T>[]
	value: T | null
	onChange: (value: T) => void
}) {
	return (
		<RadioGroup
			aria-label={label}
			value={value}
			onChange={(next) => onChange(next as T)}
			className="grid grid-cols-1 gap-3 sm:grid-cols-2"
		>
			{options.map((option) => (
				<div
					key={option.value}
					className="rounded-ds-card border border-ds-border p-4 has-[[data-selected]]:border-ds-primary has-[[data-selected]]:bg-ds-primary/5"
				>
					<Radio value={option.value}>
						<span className="block">
							<span className="block text-sm font-medium text-ds-text">{option.title}</span>
							{option.detail ? <span className="block text-sm text-ds-text-muted">{option.detail}</span> : null}
						</span>
					</Radio>
				</div>
			))}
		</RadioGroup>
	)
}
